
import Vue from 'vue';
import BookingLogo from '@/core/components/BookingLogo.vue';
import ConfirmationDialog from '@/core/components/ConfirmationDialog.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { Booking } from '@/models/bookings';
import * as TelliqService from '@/services/telliq.service';
import { emitter } from '@/utils/constants';
import Spinner from '@/core/components/Spinner.vue';
import moment from 'moment';
import { ConfirmationDialogText, confirmationDialogText } from '@/utils/functions';

@Component({
  components: {
    BookingLogo,
    ConfirmationDialog,
    Spinner,
  },
})
export default class BookingItem extends Vue {
  @Prop() readonly booking: Booking;
  @Prop() readonly completed: boolean;

  loading = false;
  show_dialog = false;

  getDialogText(): ConfirmationDialogText {
    return confirmationDialogText();
  }

  get canBeCanceled(): boolean {
    return moment().isBefore(this.booking.startDate);
  }

  get isActiveBooking(): boolean {
    const now = moment();
    return moment(this.booking.startDate).isBefore(now) && moment(this.booking.endDate).isAfter(now);
  }

  onChangeDetailsClick(): void {
    this.$router.push(`/booking/edit/${this.booking.id}`);
  }

  onCancelBookingClick(): void {
    this.show_dialog = true;
  }

  onCheckoutBookingClicked(): void {
    this.$router.push(`/booking/edit/${this.booking.id}?checkout=confirm`);
  }

  async onDialogResponse(response: boolean): Promise<void> {
    this.show_dialog = false;

    if (response) {
      this.loading = true;
      try {
        await TelliqService.deleteBooking(this.booking.id);
        this.$emit('deleted', this.booking.id);
      } catch (e) {
        emitter.emit('notify', {
          text: this.$t('core.errors.something_went_wrong'),
          color: 'error',
        });
      }
      this.loading = false;
    }
  }
}
